import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function SyncPage({ setGuilds, setMemberGuilds }) {
  const navigate = useNavigate();

  useEffect(() => {
    const performSync = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const token = localStorage.getItem("kami_token");
      if (!token) return navigate("/");

      try {
        const res = await fetch(`${API_BASE}/auth/refresh-guilds`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();

        if (data.guilds) {
          setGuilds(data.guilds);
          localStorage.setItem("kami_guilds", JSON.stringify(data.guilds));
        }
        if (data.memberGuilds && setMemberGuilds) {
          setMemberGuilds(data.memberGuilds);
          localStorage.setItem(
            "kami_member_guilds",
            JSON.stringify(data.memberGuilds),
          );
        }
        localStorage.setItem("kami_guilds_synced_at", String(Date.now()));

        navigate("/servers");
      } catch {
        navigate("/servers");
      }
    };

    performSync();
  }, [navigate, setGuilds, setMemberGuilds]);

  return (
    <div className="sync-page">
      <div className="sync-card">
        <div className="sync-spinner" aria-hidden="true" />
        <h2>Updating your servers</h2>
        <p>Fetching the latest list from Discord…</p>
      </div>
    </div>
  );
}
